import { render, staticRenderFns } from "./RecentFilesWebpart.vue?vue&type=template&id=5ce4e070"
import script from "./RecentFilesWebpart.ts?vue&type=script&lang=ts&external"
export * from "./RecentFilesWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports